// Company data
export const CompanyName = 'Cat App';
export const CompanyPhoneNumber = '07846286385';
export const ContactEmailAddress = 'hello@cat-app.app';
export const DirectorName = 'Tom Brockington';

export const CompantTagLine = 'If it does not exist we can invent it for you!';
export const SubtitleMain = 'Bringing crazy projects to life!';
export const SubtitleSecondary = `How can ${CompanyName} help you? `;


// Cookie data
export const NumberOfCookies = 0;
export const COOKIE_TIMER = 5000;
export const CookiePolicyName = 'CookiePolicy';

// URL
export const FULL_BUSINESS_URL = 'https://www.cat-app.app';
export const SHORT_BUSINESS_URL = 'cat-app.app';
export const DISPLAY_BUSINESS_URL = 'www.cat-app.app';

// Sponsor
export const SPONSOR_MAIN_URL = "https://yummies.com"

// API
export const SUBMIT_CONTACT_FORM_API = '/contact/submit-form'; // userId

// Bot Data
export const BotName = 'Jerry'

// Social Media Services
export const FACEBOOK_SERVICE = 'facebook';
export const INSTAGRAM_SERVICE = 'instagram';
export const GOOGLE_SERVICE = 'google';

// Social Media URLs
export const FACEBOOK_URL = 'https://facebook.com/';
export const INSTAGRAM_URL = 'https://instagram.com/';
export const GOOGLE_URL = 'https://google.com/';

export const FACEBOOK_NAME = 'cat-app';
export const INSTAGRAM_NAME = 'cat-app';

export const FACEBOOK_BUSINESS_URL = `https://www.facebook.com/company/cat-app`;
export const INSTAGRAM_BUSINESS_URL = `https://instagram.com/cat-app`;